import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html'
})
export class InfoDialogComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
